module.exports = __webpack_public_path__ + "6ede2a319f8df78217a5ad51520a44dd.png";